import { Flex } from '@backyard-ui/core'

import { ArchivedMessageItem } from '../ArchivedMessageItem'

type Message = {
  id: string
  title: string
  option: string
  date: string
  isOpenThread?: boolean
  hasNewMessage?: boolean
}

type ArchivedMessageListProps = {
  list: Message[]
  onClick: (id: string) => void
}

const ArchivedMessageList = (props: Readonly<ArchivedMessageListProps>) => {
  const { list, onClick } = props

  return (
    <Flex direction="column">
      {list.map((item, index) => (
        <div
          key={`archived-chat-${index}`}
          className="border-t border-gray-300 last:border-b">
          <ArchivedMessageItem data={item} onClick={onClick} />
        </div>
      ))}
    </Flex>
  )
}

export default ArchivedMessageList
